<template>
  <div style="position:fixed; z-index:999; -webkit-transform:translate3d(0,0,200); transform:translate3d(0,0,200); overflow: auto;">
    <v-bottom-nav
      v-if="links"
      class="navmobile"
      style="min-width: 650px;"
      :active.sync="bottomNav"
      :color="color"
      :value="!inputValue"
      :app="true"
      dark
      shift
      hide-on-scroll    
      >
      <div>
        <v-btn
          :title="strings[idioma].menu"
          :value="bottomNav"
          @click="inputValue = !inputValue"
          dark
          key="i-more">
          <template>
            
            <v-icon>mdi-view-list</v-icon>

          </template>
        </v-btn>
      </div>
      <div
          v-for="(link, i) in ((user.pecuarista) ? links.filter(l => (!l.naoAparecer || !l.naoAparecer.includes('pecuarista')) &&  !l.oculta) : links.filter(l => !l.oculta)).slice(0, 6)" 
          @click="linkTo(link.to)">
        <v-btn 
          dark
          :title="link.text[idioma]"
          :value="i"
          :key="i">
          <template>
            <span class="text-xs-center" style="font-size: 12px; text-overflow: ellipsis; overflow: hidden; width: 100%;">{{ link.text[idioma] }}</span>
            <v-icon>{{ link.icon }}</v-icon>
          </template>
        </v-btn>
      </div>
      
    </v-bottom-nav>
  </div> 
</template>
<script>
import { mapMutations, mapState } from 'vuex'

export default {
  data () {
    return {
      bottomNav: -1
    }
  },

  computed: {
    ...mapState('app', ['menus', 'image', 'color', 'idioma', 'links', 'strings', 'trava_back', 'user', 'empresa', 'loading', 'descricaoLogoPrincipal']),
    color () {
      switch (this.bottomNav) {
        case 0: return 'blue-grey'
        case 1: return 'teal'
        case 2: return 'brown'
        case 3: return 'indigo'
        case 4: return 'green'
        case 5: return 'red'
        case 6: return 'cyan-grey'
        default: return 'cyan-grey'
      }
    },
    inputValue: {
        get () {
          if (this.$route.path === '/dashboard' && this.$vuetify.breakpoint.width > 991) return true
          return this.$store.state.app.drawer
        },
        set (val) {
          this.setDrawer(val)
        }
      }
  },
  watch: {
    bottomNav (val, old) {
      if (parseInt(val) === -1 && parseInt(old) !== -1) {
        return false
      }
    },
    '$route.path' (val) {
      const user = this.user
      const links = this.links ? this.links : []
      const links_ = (user.pecuarista) ? links.filter(l => (!l.naoAparecer || !l.naoAparecer.includes('pecuarista')) &&  !l.oculta) : links.filter(l => !l.oculta)
      for (const i in links_){
        const link_ = links_[i]
        if (val === link_.to) {
          this.bottomNav = parseInt(i)
          
          break
        }
      }
    }
  },
  mounted () {
    const user = this.user
    const links = this.links ? this.links : []
    const links_ = (user.pecuarista) ? links.filter(l => (!l.naoAparecer || !l.naoAparecer.includes('pecuarista')) &&  !l.oculta) : links.filter(l => !l.oculta)
    for (const i in links_){
      const link_ = links_[i]
      if (this.$route.path === link_.to) {
        this.bottomNav = parseInt(i)
        
        break
      }
    }
    
  },
  methods: {
    ...mapMutations('app', ['setDrawer', 'toggleDrawer']),
    linkTo (to, force = false) {
      if (force) window.location.href = to
      if ((this.$route.path === to || this.$route.path === '/dashboard') && (!this.trava_back || (this.trava_back && confirm(this.strings[this.idioma].msg_sair)))) { window.location.href = to }
      else this.$router.push(to);
    }
  }
}
</script>